import { css } from "#styled-system/css";

export const RADIO_GROUP_STYLE = css.raw({
  "&[data-disabled]": {
    _disabled: { cursor: "not-allowed", opacity: 0.5 },
  },

  '& [data-scope="radio-group"][data-part="label"]': {
    display: "block",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 10 / 7,
  },

  '& [data-scope="radio-group"][data-part="item"]': {
    alignItems: "center",
    backgroundColor: "white",
    borderColor: "#E5E5E5",
    borderRadius: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    columnGap: "8px",
    cursor: "pointer",
    display: "grid",
    gridTemplateAreas: '"control text" ". description"',
    gridTemplateColumns: "auto 1fr",
    marginTop: "8px",
    padding: "10px",
    rowGap: "6px",
    transition:
      "backgroundColor 0.1s ease-in, borderColor 0.1s ease-in, filter 0.1s ease-in-out, transform 0.1s ease-in",

    _active: { filter: "brightness(0.9)", transform: "scale(0.975)" },
    _disabled: { cursor: "not-allowed", opacity: 0.5 },
    _focus: { filter: "brightness(0.975)" },
    _hover: { filter: "brightness(0.95)" },
  },
  '& [data-scope="radio-group"][data-part="item"][data-state="checked"]': {
    backgroundColor: "#F3F3F3",
    borderColor: "#B9B9B9",
  },

  '& [data-scope="radio-group"][data-part="item-control"]': {
    borderColor: "#E5E5E5",
    borderRadius: "50%",
    borderStyle: "solid",
    borderWidth: "1px",
    gridArea: "control",
    height: "16px",
    width: "16px",
  },
  '& [data-scope="radio-group"][data-part="item-control"][data-state="checked"]': {
    borderColor: "#171717",
    borderWidth: "4px",
  },
  '& [data-scope="radio-group"][data-part="item-text"]': {
    color: "#0A0A0A",
    fontSize: "14px",
    fontWeight: 500,
    gridArea: "text",
    lineHeight: 1,
    minWidth: 0,
    overflowX: "clip",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  '& [data-scope="radio-group"][data-part="item-description"]': {
    color: "#737373",
    fontSize: "14px",
    fontWeight: 400,
    gridArea: "description",
    lineHeight: 10 / 7,
    marginTop: "-2px",
  },
});
